import {createFileRoute} from '@tanstack/react-router';

import {SettingsSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ProjectSettings} from '~components/settings/ProjectSettings';
import {ProjectSettingsTabs} from '~components/settings/ProjectSettingsTab';

export const Route = createFileRoute('/settings/general')({
  component: SettingsGeneralPage,
  validateSearch: SettingsSearchParams.validate,
});

function SettingsGeneralPage(): JSX.Element {
  return (
    <BaseLayout>
      <ProjectSettings tabName={ProjectSettingsTabs.General} />
    </BaseLayout>
  );
}
